document.addEventListener("DOMContentLoaded", () => {
  const carousels = document.querySelectorAll(".featured-carousel");
  const breakpoint = 768; // Screen width breakpoint in pixels
  let itemsPerPage = window.innerWidth < breakpoint ? 2 : 3;

  const updateItemsPerPage = () => {
    itemsPerPage = window.innerWidth < breakpoint ? 2 : 3;
  };

  const setupCarousel = (carousel) => {
    const inner = carousel.querySelector(".featured-carousel-inner");
    const prevBtn = carousel.querySelector(".prev");
    const nextBtn = carousel.querySelector(".next");
    const indicatorWrapper = carousel.querySelector(".indicator-wrapper");
    const items = Array.from(inner.querySelectorAll(".card-wrapper"));
    const indicatorContainer = document.createElement("div");
    indicatorContainer.className = "caro-indicators";
    indicatorWrapper.appendChild(indicatorContainer);

    let activeItemIndex = 0; // Track current item index
    let autoSlideInterval; // Interval for auto-sliding
    let autoSlideTimeout; // Timeout for user interaction pause

    const startAutoSlide = () => {
      stopAutoSlide(); // Clear any existing interval
      autoSlideInterval = setInterval(() => {
        nextSlide(); // Automatically slide to the next item
      }, 8000);
    };

    const stopAutoSlide = () => {
      clearInterval(autoSlideInterval); // Stop the auto-slide interval
    };

    const pauseAutoSlide = () => {
      stopAutoSlide(); // Stop the current interval
      clearTimeout(autoSlideTimeout); // Clear any existing timeout
      autoSlideTimeout = setTimeout(() => {
        startAutoSlide(); // Resume auto-sliding after 10 seconds
      }, 10000);
    };

    const updateIndicators = () => {
      const totalGroups = items.length - itemsPerPage + 1;
      indicatorContainer.innerHTML = ""; // Clear previous indicators

      for (let i = 0; i < totalGroups; i++) {
        const dot = document.createElement("div");
        dot.className = "caro-indicator";
        if (i === activeItemIndex) dot.classList.add("caro-indicator-active");
        dot.addEventListener("click", () => {
          activeItemIndex = i;
          updateCarouselPosition();
          updateIndicators();
          //pauseAutoSlide(); // Pause auto-sliding on indicator click
        });
        indicatorContainer.appendChild(dot);
      }
    };

    const updateCarouselPosition = () => {
      const itemWidthPercentage = 100 / itemsPerPage; // Width of a single item as a percentage of visible items
      const offset = activeItemIndex * -itemWidthPercentage; // Move one full item width
      inner.style.transform = `translateX(${offset}%)`;
      updateIndicators();
    };

    const prevSlide = () => {
      if (activeItemIndex === 0) {
        activeItemIndex = items.length - itemsPerPage; // Wrap around to the end
      } else {
        activeItemIndex -= 1; // Move left by one item
      }
      updateCarouselPosition();
      //pauseAutoSlide(); // Pause auto-sliding on user interaction
    };

    const nextSlide = () => {
      if (activeItemIndex === items.length - itemsPerPage) {
        activeItemIndex = 0; // Wrap around to the beginning
      } else {
        activeItemIndex += 1; // Move right by one item
      }
      updateCarouselPosition();
      //pauseAutoSlide(); // Pause auto-sliding on user interaction
    };

    // Attach event listeners
    prevBtn.addEventListener("click", prevSlide);
    nextBtn.addEventListener("click", nextSlide);

    // Recalculate on resize
    const handleResize = () => {
      updateItemsPerPage();
      activeItemIndex = 0; // Reset to the first item
      updateCarouselPosition();
    };

    // Set up initial items
    updateIndicators();
    updateCarouselPosition();

    // Start auto-sliding
    startAutoSlide();

    // Attach resize event listener
    window.addEventListener("resize", handleResize);
  };

  carousels.forEach(setupCarousel);
});




